export default __webpack_public_path__ + "static/media/325.75403fb7.jpg";